const multipleSaleText = {
  'multipleSaleText.withMultipleSale':
    'Необходимо приобрести не менее {minSaleCount} шт., при этом количество должно быть кратно {multipleSaleCount}',
  'multipleSaleText.withoutMultipleSale': 'Необходимо приобрести не менее {minSaleCount} шт.',
  'multipleSaleText.withoutMinSaleCount': 'Количество должно быть кратно {multipleSaleCount}',
};

export default multipleSaleText;
